export const rootStyles = {
  padding: '4px 12px',
  minHeight: 20,
};
